__turbopack_context__.v({
  "desktopMenuWrapper": "tz5CgW_desktopMenuWrapper",
  "desktopMenuWrapperFixed": "tz5CgW_desktopMenuWrapperFixed",
  "mainContainer": "tz5CgW_mainContainer",
  "menuItemContainer": "tz5CgW_menuItemContainer",
  "navbarPlaceholder": "tz5CgW_navbarPlaceholder",
  "simpleMenuContainer": "tz5CgW_simpleMenuContainer",
});
